import React, { useEffect, useState } from "react";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import MaterialTable from "material-table";
import Top from "../Top";
import { API_URL } from "../../../config";
import { Link, useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Loader from "../Loader/Loader";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const EditTutorialRecordings = () => {
  const classes = useStyles();
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);

  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const deleteToggleModal = () => setDeleteModal(!deleteModal);

  const [deletesuccessModal, setDeletesuccessModal] = useState(false);
  const deletesuccessToggleModal = () =>
    setDeletesuccessModal(!deletesuccessModal);
  const [deviceid, setDeviceid] = useState(null);
  const [fetchdata, setFetchdata] = useState(true);

  const user_type = localStorage.getItem("user_type");

  useEffect(() => {
    tutorialList();
  }, []);

  const deleteDevice = () => {
    fetch(API_URL + "/delete/tutorial/recording/by/" + deviceid, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          tutorialList();
          deleteToggleModal();
          deletesuccessToggleModal();
        });
      } else {
        alert("Network error");
      }
    });
  };
  const handleButtonClick = (videoUrl) => {
    const newTab = window.open("", "_blank");
    newTab.document.write(`
      <video controls autoplay width='100%', height='100%'>
        <source src="${videoUrl}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    `);
  };

  const tutorialList = () => {
    fetch(API_URL + "/get/all/tutorials/recordings", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          resp.data.map((v, i) => {
            _temp.push({
              category_name: v.category_name == null ? "NA" : v.category_name,
              recording_name:
                v.recording_name == null ? "NA" : v.recording_name,
              status:
                v.status == null ? "NA" : v.status == 1 ? "Active" : "Inactive",
              recording_type:
                v.recording_type == null
                  ? "NA"
                  : v.recording_type == 1
                  ? "Link"
                  : "Video",
              action: (
                <ul className="action-list">
                  <li>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Edit"
                      placement="top"
                    >
                      <Link
                        to={"/upload-tutorial-recordings/" + v.id}
                        className="view-patient"
                      >
                        <i
                          className="fa fa-pencil-square-o"
                          aria-hidden="true"
                        ></i>
                      </Link>
                    </Tooltip>
                    {user_type != 8 && (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="Delete"
                        placement="top"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={() => {
                            deleteItempopUp(v.id);
                          }}
                          className="view-patient"
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </a>
                      </Tooltip>
                    )}
                    {v.recording_type != 1 ? (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="Download"
                        placement="top"
                      >
                        <a
                          href={v.recording}
                          className="view-patient"
                          target="_blank"
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>
                        </a>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                    {v.recording_type == 2 ? (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="View"
                        placement="top"
                      >
                        <button
                          onClick={() => handleButtonClick(v.recording)}
                          className="tooltip-btn"
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </button>
                      </Tooltip>
                    ) : v.recording_type == 1 ? (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="View"
                        placement="top"
                      >
                        <a
                          href={v.recording}
                          className="view-patient"
                          target="_blank"
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </a>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </li>
                </ul>
              ),
            });
          });
          setFetchdata(false);
          setData(_temp);
        });
      }
    });
  };
  const columns = [
    {
      title: "Category Name",
      field: "category_name",
    },
    {
      title: "Tutorial Recording Name",
      field: "recording_name",
    },

    {
      title: "Recording Type",
      field: "recording_type",
    },
    {
      title: "Stauts",
      field: "status",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];

  const deleteItempopUp = (id) => {
    if (deleteModal == false) {
      setDeviceid(id);
      setDeleteModal(!deleteModal);
    } else {
      setDeviceid(id);
      setDeleteModal(deleteModal);
    }
  };

  const handleGoBack = () => {
    navigation("/tutorial-recordings");
  };

  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="head-listing">
              <h3>Tutorial Recordings</h3>
            </div>
            <div className="add-btn">
              <button onClick={handleGoBack}>Go Back</button>
            </div>
          </div>

          <Modal
            isOpen={deleteModal}
            toggle={deleteToggleModal}
            className="connect-box"
            centered={true}
          >
            <ModalBody>
              <div className="deletemodal-content">
                <h6>
                  <i
                    onClick={() => setDeleteModal(false)}
                    className="fa fa-times"
                    aria-hidden="true"
                  ></i>
                </h6>
                <div className="deleteCircle">
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </div>
                <h3>Are you sure?</h3>
                <p className="para">
                  Do you really want to delete the record? This process cannot
                  be undone.
                </p>

                <div className="butn-wrp">
                  <button
                    className="delete-cancel-btn"
                    onClick={deleteToggleModal}
                  >
                    Cancel
                  </button>
                  <button onClick={deleteDevice}>Delete</button>
                </div>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={deletesuccessModal}
            toggle={deletesuccessToggleModal}
            className="connect-box"
            centered={true}
          >
            <ModalHeader toggle={deletesuccessToggleModal}>
              <span className="ml-1 roititle ">Successfull</span>
            </ModalHeader>
            <ModalBody>
              <div className="modal-paragrph">
                <p>Tutorial recording has been deleted successfully</p>
              </div>
            </ModalBody>
          </Modal>

          <div className="wrp-bankform">
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                {fetchdata ? (
                  <div className="norecordfound">Fetching record</div>
                ) : (
                  data.length > 0 && (
                    <MaterialTable
                      options={{
                        search: true,
                        showTitle: false,
                        pageSize:
                          data.length <= 5
                            ? 5
                            : data.length > 5 && data.length <= 10
                            ? 10
                            : data.length > 10 && data.length <= 20
                            ? 20
                            : data.length > 20 && data.length <= 30
                            ? 30
                            : data.length > 30 && data.length <= 40
                            ? 40
                            : data.length > 40 && data.length <= 50
                            ? 50
                            : data.length > 50 && data.length <= 100
                            ? 100
                            : 150,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                      }}
                      columns={columns}
                      data={data}
                      title=""
                    />
                  )
                )}

                {fetchdata
                  ? ""
                  : data.length == 0 && (
                      <MaterialTable
                        options={{
                          showTitle: false,
                        }}
                        columns={columns}
                        showTitle={false}
                        pagination={true}
                      />
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTutorialRecordings;
